import React from 'react';
import {useIntl} from 'react-intl';
import {Select} from 'components/Form';

interface LearningStatusSelectInterface {
    name?: string | string[];
    label?: string;
    layout?: {
        labelCol: {
            span: number
        }
        wrapperCol: {
            span: number
        }
    }
    disabled?: boolean;
    customRules?: any;
    type: string;
    hasDefaultLayout?: boolean;
    isFormItem?: boolean;
    onChange: any;
}

const LearningStatusSelect: React.FC<LearningStatusSelectInterface> = ({
                                                                           name,
                                                                           label,
                                                                           type,
                                                                           layout,
                                                                           disabled = false,
                                                                           customRules = [],
                                                                           hasDefaultLayout,
                                                                           isFormItem = true,
                                                                           onChange
                                                                       }) => {
    const intl = useIntl();

    const expectedResult = {
        'NOT_STARTED': intl.formatMessage({id: 'general.not_started'}),
        'COMPLETED': intl.formatMessage({id: 'general.completed'}),
        'NOT_APPLICABLE': intl.formatMessage({id: 'general.not_applicable'}),
    };

    const assessmentResult = {
        'NOT_STARTED': intl.formatMessage({id: 'general.not_started'}),
        'PASSED': intl.formatMessage({id: 'general.passed'}),
        'NOT_APPLICABLE': intl.formatMessage({id: 'general.not_applicable'}),
    };

    let formItemLayout = layout || {}

    if (hasDefaultLayout) {
        formItemLayout = {
            labelCol: {span: 6},
            wrapperCol: {span: 18}
        }
    }

    return (
        <Select
            customLayout={formItemLayout}
            isFormItem={isFormItem}
            name={name}
            label={label ? intl.formatMessage({id: label}) : null}
            manualOptions={type === 'ASSESSMENT' ? assessmentResult : expectedResult}
            onChange={() => onChange ? onChange(name): null}
            disabled={disabled}
            customRules={customRules}
        />
    )
}
export default LearningStatusSelect;
